import React from 'react';
import SectionOutlet from './SectionOutlet';

const Phase1Layout: React.FC = () => <SectionOutlet section="phase-1" />;

export default Phase1Layout;
